import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchProtectedData } from "../features/auth/authSlice";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, authChecked } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!authChecked) {
      dispatch(fetchProtectedData());
    }
  }, [dispatch, authChecked]);

  if (!authChecked || loading) {
    return <div>Checking authentication...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default PrivateRoute;
